import { Inject, Injectable } from "@angular/core";
import { UserService } from "@app/services/user/user.service";
import { SESSION_STORAGE, StorageService } from "ngx-webstorage-service";
import { RangeService } from "@app/services/ranges/range-service";

@Injectable({
  providedIn: "root",
})
export class VoyageRangeService extends RangeService {
  constructor(userService: UserService, @Inject(SESSION_STORAGE) storage: StorageService) {
    super(userService, storage, {
      storageRangeKey: "fo-voyage-range",
      userPropertyKey: "voyagePeriod",
    });
  }
  protected override populateFromUser(user: any): void {}
}
